<script>
export default {
  methods: {
    notifyVue: function (type, message) {
      /** '', 'info', 'success', 'warning', 'danger' */
      Messenger().post({
        extraClasses: 'messenger-fixed messenger-on-bottom',
        message: message,
        type: type,
        showCloseButton: false,
        theme: 'air',

      });


    }

  }


}
</script>

<style src="@/pages/Ui/Notifications/Notifications.scss" lang="scss" scoped />